<template>
  <div class="total1 animate__animated animate__fadein animate__delay-0.5s animate__slower" ref="total">
    <div class="logo" @click="$router.push('/indexno')"></div>
    <div class="container">
      <div v-if="methods == 1">
        <div class="title">验证码登录</div>
        <div class="inputbox" style="margin-top: .2188rem;">
          <input v-model.lazy="phone" placeholder="请输入手机号">
          <img src="../../assets/loginusername.png" style="width: .1042rem;height: .1042rem;" alt="">
        </div>
        <button class="greenbtn" style="margin-left: .1302rem;" @click="getCode">{{ codemessage }} </button>
        <div class="inputbox" style="display:block">
          <input v-model="code" placeholder="请输入验证码 ">
          <img src="../../assets/loginlock.png" style="width: .1042rem;height: .1042rem;" alt="">
        </div>
        <button class="greenbtn" :round=true @click="codelogin"
          style="margin-top: .1042rem;margin-left: 1.2083rem;border-radius:.5208rem;"><span
            v-if="identity == 0">教师</span><span v-else>家长</span>登录</button>
        <div class="logintxt">
          <div style="text-align: center;cursor: pointer;">未注册用户将自动创建新账号</div>
          <div style="text-align: center;cursor: pointer;">登录即代表您以阅读并同意<a @click="$router.push('/yonghuxieyi')">
              《用户协议》</a></div>
        </div>

        <button @click="methods = 2" class="whitebtn" style="margin-left: .6771rem;">密码登录</button>
        <button @click="wechat" class="whitebtn">微信登录</button>
      </div>
      <div v-if="methods == 2">
        <div class="title">密码登录</div>
        <div class="inputbox" style="margin-top: .2188rem;margin-left: .6771rem;">
          <input v-model.lazy="username" placeholder="请输入手机号">
          <img src="../../assets/loginusername.png" style="width: .1042rem;height: .1042rem;" alt="">
        </div>
        <div class="inputbox" style="display:block;margin-left: .6771rem;">
          <input v-model="pwd" type="password" placeholder="请输入密码 ">

          <img src="../../assets/loginlock.png" style="width: .1042rem;height: .1042rem;" alt="">
        </div>
        <button class="greenbtn" :round=true @click="login"
          style="margin-left: 1.25rem;margin-top: .1042rem;border-radius:.5208rem;"><span
            v-if="identity == 0">教师</span><span v-else>家长</span>登录</button>
        <div class="logintxt">
          <div style="text-align: center;cursor: pointer;">未注册用户将自动创建新账号</div>
          <div style="text-align: center;cursor: pointer;">登录即代表您以阅读并同意<a @click="$router.push('/yonghuxieyi')">
              《用户协议》</a></div>
        </div>
        <button @click="methods = 1" class="whitebtn" style="margin-left: .6771rem;">验证码登录</button>
        <button @click="wechat" class="whitebtn">微信登录</button>
      </div>
      <div v-if="methods == 3">
        <div class="title">微信登录</div>
        <div class="wx">
          <wxlogin :appid="appid" :scope="'snsapi_login'" :theme="'white'" :redirect_uri="redirect_uri" :state="state"
            href="data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDEwMCU7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTpub25lO30KLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lfQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fSAK">
          </wxlogin>
        </div>
        <button @click="methods = 1" class="whitebtn" style="margin-left: .6771rem;">验证码登录</button>
        <button @click="methods = 2" class="whitebtn">密码登录</button>
      </div>

    </div>
  </div>
</template>

<script>

import wxlogin from 'vue-wxlogin'
export default {

  components: { wxlogin },
  data() {
    return {
      methods: 1,
      phone: '',
      code: '',
      username: '',
      pwd: '',
      identity: '',
      codemessage: '获取验证码',
      appid: '',
      redirect_uri: '',
      state: ''
    }
  },

  methods: {

    getCode() {
      // 如果正在倒计时，直接返回
      if (this.codemessage !== '获取验证码') {
        return;
      }

      // 手机号码的正则匹配
      let phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.phone)) {
        this.$message({
          message: '请输入有效的手机号码',
          type: 'error'
        });
        return;
      }

      let formdataPhone = new FormData();
      formdataPhone.append('phone', this.phone);
      this.$http.post('/Api/User/User/Web/Code/Login', formdataPhone).then(res => {
        this.$message({
          message: '获取验证码成功',
          type: 'success'
        });

        // 开始倒计时
        let countdown = 60;
        this.codemessage = countdown + '秒后获取';
        let timer = setInterval(() => {
          countdown--;
          if (countdown <= 0) {
            // 倒计时结束，清除定时器
            clearInterval(timer);
            this.codemessage = '获取验证码';
          } else {
            this.codemessage = countdown + '秒后获取';
          }
        }, 1000);
      }).catch(error => {
        // console.log(error.response.data);
      });
    },
    codelogin() {
      let formdataPhone = new FormData();
      formdataPhone.append('phone', this.phone);
      formdataPhone.append('code', this.code);
      this.$http.post('/Api/User/User/Web/Code/Login/Callback', formdataPhone, {
        headers: {
          'Access-Control-Expose-Headers': 'Authorization'
        }
      }).then(res => {
        // console.log(res.data.msg);

        if (res.data.code == 200) {

          localStorage.setItem('Authorization', res.data.data.token)
          localStorage.setItem('uid', res.data.data.uid)
          if (res.data.data.isParent == 0 && res.data.data.isTeacher == 0) {
            if (this.identity == 0) {
              this.$router.push('/indexteacher');
            }
            else {
              this.$router.push('/indexstudent');
            }
          }
          else {
            if (this.identity == 0 && res.data.data.isTeacher == 1) {
              this.$router.push('/indexteacher');
              // localStorage.setItem('identity', 'teacher')
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            }
            else if (this.identity == 1 && res.data.data.isParent == 1) {
              this.$router.push('/indexstudent');
              // localStorage.setItem('identity', 'student')
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            }
            else {
              this.$message({
                message: '与上次登录身份不符',
                type: 'error'
              });

            }
          }

        }
        else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }


      }).catch(error => {
        // console.log(error.data.msg);
        this.$message({
          message: error.data.msg,
          type: 'error'
        });
      });
    },
    login() {
      // console.log(this.identity);
      let count = 0
      for (let key in this.$data) {
        if (!(this.$data[key] == '' || this.$data[key].length == 0)) {
          count++
        }
      }
      if (count < 4) {
        this.$message({
          message: '请填写完整信息',
          type: 'warning'
        });
        return
      }
      let phonelog = {
        phone: this.username,
        password: this.pwd
      }
      this.$http.post('/Api/User/User/Web/Login', JSON.stringify(phonelog), {
        headers: {
          'content-type': 'application/json'
        }
      })
        .then(res => {
          // console.log(res.data.data);
          if (res.data.code == 200) {

            localStorage.setItem('Authorization', res.data.data.token)
            localStorage.setItem('uid', res.data.data.uid)
            if (this.identity == 0 && res.data.data.isTeacher == 1) {
              this.$router.push('/indexteacher');
              // localStorage.setItem('identity', 'teacher')
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            }
            else if (this.identity == 1 && res.data.data.isParent == 1) {
              this.$router.push('/indexstudent');
              // localStorage.setItem('identity', 'student')
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            }
            else {
              this.$message({
                message: '与上次登录身份不符',
                type: 'error'
              });

            }
          }
          else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        }).catch(error => {
          // console.log(error);
        });


    },
    wechat() {
      this.methods = 3
      // this.$http.post('/Api/User/User/Web/Wechat/Login', {
      //   redirect_uri: 'http://localhost:8080/#/login/'
      // }).then(res => {
      //   console.log(res.data);
      //   let URL = res.data.slice(9)
      //   function getUrlParams2(url) {
      //     let urlStr = url.split('?')[1]
      //     const urlSearchParams = new URLSearchParams(urlStr)
      //     const result = Object.fromEntries(urlSearchParams.entries())
      //     return result
      //   }
      //   console.log(getUrlParams2(URL))
      //   // window.open(res.data.slice(9))
      //   let params = new URLSearchParams(url.search);

      //   this.appid = params.get('appid');
      //   console.log(this.appid);
      //   this.redirect_uri = params.get('redirect_uri');
      // })
      this.$http.post('/Api/User/User/Web/Wechat/Login', {
        redirect_uri: 'https://localhost:8080/#/login/'
      }).then(res => {
        // console.log(res.data);
        let url = new URL(res.data.slice(9));
        let params = new URLSearchParams(url.search);
        this.appid = params.get('appid');
        this.redirect_uri = encodeURIComponent(params.get('redirect_uri'));
        console.log(params.get('redirect_uri'));
        this.state = params.get('state');
      })


    }
  },
  created() {
    if (this.$route.query.code && this.$route.query.uid) {
      this.$http.post('/Api/User/User/Web/Wechat/Login/Callback/Callback', {}, {
        params: {
          uid: this.$route.query.uid,
          code: this.$route.query.code
        }
      }).then(res => {
        // console.log(res);
        if (res.data.data.isParent == 1) {
          localStorage.setItem('identity', 1)
        }
        else {
          localStorage.setItem('identity', 0)
        }
        localStorage.setItem('Authorization', res.data.data.token)
        localStorage.setItem('uid', res.data.data.uid)
        localStorage.setItem('isPhone', res.data.data.isPhone)
        if (localStorage.getItem('identity') == 0)
          this.$router.push('/indexteacher');
        else if (localStorage.getItem('identity') == 1)
          this.$router.push('/indexstudent');

      })
    }
    else {
      if (localStorage.getItem('identity')) {
        this.identity = localStorage.getItem('identity')
      } else {
        this.identity = this.$route.query.id
        // console.log(this.identity);
        localStorage.setItem('identity', this.identity)
      }
    }


  },

  watch: {
    identity(newValue, oldValue) {
      if (newValue == 1) {
        this.$refs.total.classList.add('total1')
        this.$refs.total.classList.remove('total0')
      }
      if (newValue == 0) {
        this.$refs.total.classList.add('total0')
        this.$refs.total.classList.remove('total1')
      }

    },

    phone(newVal, oldVal) {
      if (!/^1[3456789]\d{9}$/.test(newVal)) {
        // this.phone = '';
        this.$message({
          message: '手机号格式不对',
          type: 'warning'
        });
      }
    },
    username(newVal, oldVal) {
      if (!/^1[3456789]\d{9}$/.test(newVal)) {
        // this.phone = '';
        this.$message({
          message: '手机号格式不对',
          type: 'warning'
        });
      }
    },
    methods(n, o) {
      this.phone = '';
      this.code = '';
      this.username = '';
      this.pwd = '';
      if (n == 3) {
        let timer = setInterval(() => {
          if (document.querySelector('iframe')) {
            clearInterval(timer)
            console.log(document.querySelector('iframe'));
            let iframe = document.querySelector('iframe')
            iframe.style.width = '100%'
            iframe.style.height = '100%'
          }
        }, 100)

      }
    }

  }
}
</script>

<style scoped>
input:focus {
  outline: none;
}

.wrp_code {
  width: 200px;
  height: 200px;
}

.wx {
  width: 260px;
  height: 285px;
  /* margin-top: 20px; */
  margin-left: 175px;
  /* border: #01A299 1px solid; */
}

.total0 {
  width: 1920px;
  height: 99vh;
  background: url('../../assets/loginbg1.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 1px;
}

.total1 {
  width: 1920px;
  height: 99vh;
  background: url('../../assets/loginbg2.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 1px;
}

.container {
  width: 622px;
  height: 483px;
  margin: 0 auto;
  background: url('../../assets/logincontainerbg.png') no-repeat center;
  background-size: 100% 100%;
  padding-top: 36px;
  border-radius:
    4px;

}

.title {
  width: 147px;
  height: 42px;
  margin: 0 auto;
  color: rgb(255, 255, 255);
  font-family: Microsoft YaHei;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
}

.form {
  text-align: left;
}

.logo {
  display: inline-block;
  width: 158px;
  height: 215px;
  margin-top: 50px;
  margin-left: 270px;
  background: url('../../assets/logo1.png');
  background-size: 100% 100%;
}

.inputbox {
  position: relative;
  width: 327px;
  height: 49px !important;
  margin-left: 84px;
  margin-top: 25px;
  display: inline-block;
}

.inputbox input {
  /* 号码框 */
  background: rgba(154, 166, 162, 0.2);

  border: none !important;
  padding-left: 48px;
  /* input-完整/large/disable/无/off/off/off/off/off */
  width: 320px;
  height: 46px;
  background: rgb(230, 246, 245);
  border: 1px solid rgb(204, 236, 235);
  border-radius:
    4px;

}

input[placeholder] {
  /* 请输入手机号码 */
  color: rgba(0, 0, 0, 0.4);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 10px;
  letter-spacing: 0px;
  text-align: left;
}

.inputbox img {
  position: absolute;
  top: 14px;
  left: 17px;
}

.greenbtn {
  width: 108px;
  height: 43px;
  background-color: #01A299;
  border: none !important;
  border-radius: 8px;
  /* 获取验证码 */
  color: rgb(255, 255, 255);
  font-family: Microsoft YaHei;
  font-size: 17px;
  font-weight: 400;
  line-height: 10px;
  letter-spacing: 0px;
  text-align: center;
}

.logintxt {
  padding-top: 12px;
  width: 350px;
  height: 60px;
  margin: 0 auto;
  transform: translateX(-10px);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
}

.logintxt a {
  color: rgb(42, 177, 141);
  text-decoration: underline;
}

.whitebtn {
  /* 密码登录 */
  color: rgb(0, 0, 0);
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  margin-left: 80px;
  margin-top: 19px;
  /* button-round/large/default/none/off/off (style) */
  width: 137px;
  height: 40px;
  box-sizing: border-box;

  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    100px;

}
</style>


// WEBPACK FOOTER //
// src/components/pages/login.vue